var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldExclamation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield-exclamation.1 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 1.94531C7.91528 3.81118 5.17437 4.95894 2.16611 4.99976C2.05686 5.65053 2 6.31906 2 7.00088C2 12.2258 5.33923 16.6707 10 18.3181C14.6608 16.6707 18 12.2258 18 7.00088C18 6.31906 17.9431 5.65053 17.8339 4.99976C14.8256 4.95894 12.0847 3.81118 10 1.94531ZM11 14.0009C11 14.5532 10.5523 15.0009 10 15.0009C9.44771 15.0009 9 14.5532 9 14.0009C9 13.4486 9.44771 13.0009 10 13.0009C10.5523 13.0009 11 13.4486 11 14.0009ZM11 7.00085C11 6.44857 10.5523 6.00085 10 6.00085C9.44771 6.00085 9 6.44857 9 7.00085V10.0009C9 10.5532 9.44771 11.0009 10 11.0009C10.5523 11.0009 11 10.5532 11 10.0009V7.00085Z",
    fill: "#D85442"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldExclamation);
export default __webpack_public_path__ + "static/media/shield-exclamation.e0e4e0b70f28fe3dfbce5fe802a19534.svg";
export { ForwardRef as ReactComponent };